import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

import { Form } from 'common/components';
import { formatNumber } from 'accounting-js';

class AssetsDepreciationInfo extends PureComponent {
  static propTypes = {
    asset: PropTypes.object.isRequired,
    t: PropTypes.func.isRequired,
  };

  render = () => (
    <div className="col-12 bbottom mb-3 mt-3">
      <div className="row">
        <div className="col-sm-12">
          <h5>
            <b>{this.props.t('assets.depreciation_info')}</b>
          </h5>
          <br />
        </div>
        <div className="col-sm-6 col-md-4 col-lg-3">
          <Form.FieldInput
            className="text-right"
            iconLeft={'usd'}
            name={'price'}
            label={this.props.t('assets.fields.price')}
            value={formatNumber(this.props.asset.price || 0, { precision: 2 })}
            readOnly={true}
          />
        </div>
        <div className="col-sm-6 col-md-4 col-lg-3">
          <Form.FieldInput
            className="text-right"
            iconLeft={'usd'}
            name={'exchange'}
            label={this.props.t('assets.fields.exchange')}
            value={formatNumber(this.props.asset.exchange || 0, { precision: 4 })}
            readOnly={true}
          />
        </div>
        <div className="col-sm-6 col-md-4 col-lg-3">
          <Form.FieldInput
            type="text"
            name={'coin'}
            label={this.props.t('assets.fields.coin')}
            value={
              this.props.asset._coin
                ? `${this.props.t(this.props.asset._coin.key)} - ${this.props.t(
                    this.props.asset._coin.value
                  )}`
                : ''
            }
            readOnly={true}
          />
        </div>
        <div className="col-sm-6 col-md-4 col-lg-3">
          <Form.FieldInput
            type="text"
            name={'account'}
            label={this.props.t('assets.fields.account')}
            value={
              this.props.asset._account
                ? `${this.props.asset._account.key} - ${this.props.asset._account.name}`
                : ''
            }
            readOnly={true}
          />
        </div>
        <div className="col-sm-6 col-md-4 col-lg-3">
          <Form.FieldInput
            type="text"
            name={'subaccount'}
            label={this.props.t('assets.fields.subaccount')}
            value={
              this.props.asset._subaccount
                ? `${this.props.asset._subaccount.key} - ${this.props.asset._subaccount.name}`
                : ''
            }
            readOnly={true}
          />
        </div>
      </div>
    </div>
  );
}

export default translate()(AssetsDepreciationInfo);



// WEBPACK FOOTER //
// src/components/assets/depreciation/AssetsDepreciationInfo.js